
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Anatomical_staging_of_trophoblastic_tumor',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Anatomical_staging_of_trophoblastic_tumor.vue